import * as React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'
import { useQueryParam } from '../../hooks/useQueryParam'

import nubrakesWhiteLogo from '../../../public/img/nubrakes-logo-no-text.svg'

type Props = {
  title: string
  cities?: { cityName: string; linkUrl: string }[]
  phoneNumberTxt?: string
  phoneNumber?: string
  buttonText?: string
}
export const BrakeRepairNearYouSection: React.FC<Props> = ({
  title,
  cities,
  phoneNumberTxt,
  phoneNumber,
  buttonText,
}) => {
  const query = useQueryParam()
  return (
    <section className="text-center">
      <Container>
        <div className="pb-4">
          <Image className="mx-auto" src={nubrakesWhiteLogo} alt={'NuBrakes Logo'} />
        </div>
        <h2 className="title">{title}</h2>
        {cities && (
          <p className="description">
            We bring the brake shop to you. Find the best
            <Link href={{ pathname: '/brake-repair-near-me', query }}>{' brake repair near you'}</Link> now.
          </p>
        )}
        {phoneNumberTxt && (
          <p className="description">
            Call us at <a href={`tel:${phoneNumber}`}>{phoneNumberTxt}</a> to speak with a brake specialist or click the
            button below to receive a free, no-obligation quote.
          </p>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cities &&
            cities.map((city, cityIndex) => {
              return (
                <Link key={cityIndex} as={{ pathname: city.linkUrl, query }} href={'/cities/[slug'}>
                  <a>{city.cityName} Brake Repair</a>
                </Link>
              )
            })}
        </div>
        <div style={{ paddingTop: '5%' }}>
          <LandingPageButton buttonText={buttonText ? buttonText : 'Get A Free Brake Service Estimate'} />
        </div>
      </Container>
    </section>
  )
}
